import * as React from 'react'

import type { TripItem } from 'tripPlanner/types/tripItem'
import { isFlightSearchBookmark } from 'tripPlanner/utils'

import type { DetailItemCardVariant } from './common/types'
import DetailAccommodationCard from './DetailAccommodationCard'
import DetailFlightCard from './DetailFlightCard'
import DetailThingToDoCard from './DetailThingToDoCard'
import DetailExperienceCard from './DetailExperienceCard'
import DetailFlightSearchCard from './DetailFlightSearchCard'
import DetailTransportCard from './DetailTransportCard'
import DetailCarRentalCard from './DetailCarRentalCard'
import DetailTourCruiseCard from './DetailTourCruiseCard'
import DetailNoteCard from './DetailNoteCard'

interface Props {
  item: TripItem
  variant: DetailItemCardVariant
  tripNameLabel?: React.ReactNode
}

function DetailItemCard({ item, variant, tripNameLabel }: Props) {
  switch (item.type) {
    case 'ACCOMMODATION':
      return (
        <DetailAccommodationCard
          item={item}
          variant={variant}
          tripNameLabel={tripNameLabel}
        />
      )
    case 'ATTRACTION':
    case 'RESTAURANT_BAR':
    case 'EVENT':
    case 'THING_TO_DO':
      return (
        <DetailThingToDoCard
          item={item}
          variant={variant}
          tripNameLabel={tripNameLabel}
        />
      )
    case 'EXPERIENCE':
      return (
        <DetailExperienceCard
          item={item}
          variant={variant}
          tripNameLabel={tripNameLabel}
        />
      )
    case 'FLIGHT':
      if (isFlightSearchBookmark(item)) {
        return <DetailFlightSearchCard
          item={item}
          variant={variant}
          tripNameLabel={tripNameLabel}
        />
      } else {
        return (
          <DetailFlightCard
            item={item}
            variant={variant}
            tripNameLabel={tripNameLabel}
          />
        )
      }
    case 'TRAIN':
    case 'BUS':
    case 'FERRY':
    case 'OTHER_TRANSPORT':
      return (
        <DetailTransportCard
          item={item}
          variant={variant}
          tripNameLabel={tripNameLabel}
        />
      )
    case 'CAR_RENTAL':
      return (
        <DetailCarRentalCard
          item={item}
          variant={variant}
          tripNameLabel={tripNameLabel}
        />
      )
    case 'TOUR':
    case 'CRUISE':
      return (
        <DetailTourCruiseCard
          item={item}
          variant={variant}
          tripNameLabel={tripNameLabel}
        />
      )
    case 'NOTE':
      return (
        <DetailNoteCard
          item={item}
          variant={variant}
          tripNameLabel={tripNameLabel}
        />
      )
    default:
      // More item types to come...
      return null
  }
}

export default DetailItemCard
